import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Header from './components/template/header';
import Footer from './components/template/footer';
import Home from './pages/Home';
import Cars from './pages/Cars';
import CarDetail from './pages/CarDetail';
import CarMake from './pages/CarMake';
import CarType from './pages/CarType';
import Search from './pages/Search';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Rental from './pages/Rental';
import Workshop from './pages/Workshop';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cars" element={<Cars />} />
            <Route path="/cars/:slug" element={<CarDetail />} />
            <Route path="/cars/make/:slug" element={<CarMake />} />
            <Route path="/cars/type/:slug" element={<CarType />} />
            <Route path="/search/:search" element={<Search />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:post" element={<BlogPost />} />
            <Route path="/rental" element={<Rental />} />
            <Route path="/workshop" element={<Workshop />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;


